import { createAction, props } from '@ngrx/store';

export const setParametrizacionFocunOnboarding = createAction(
  '[Parametrizacion Focun] Set Parametrizacion Focun Onboarding',
  props<{ status: boolean }>()
);
